<h5>配送アラート</h5>
<div class="tw-h-[250px] tw-overflow-y-auto">
  <mat-accordion multi>
    <mat-expansion-panel [expanded]="true">
      @for (alertsPerShipment of alertList; track alertsPerShipment.status) {
        @if (alertsPerShipment) {
          <div
            class="tw-flex tw-items-center tw-w-full tw-h-[55px]"
            [ngClass]="{
              '!tw-bg-red-100': !isResolved(alertsPerShipment),
              '!tw-bg-gray-300': isResolved(alertsPerShipment),
            }"
          >
            <div
              class="tw-ml-3 tw-text-xl tw-min-w-[20%] tw-max-w-[25%] tw-flex"
            >
              <a
                [routerLink]="['/shipment-info']"
                [queryParams]="getShipmentInfoLinkPrams(alertsPerShipment)"
                class="tw-max-w-56 tw-truncate"
              >
                {{ alertsPerShipment.shipmentName }}
              </a>
            </div>
            <div class="tw-flex tw-w-full">
              <div class="tw-flex tw-min-w-[20%] tw-max-w-[25%]">
                <span>{{ getAlertStatus(alertsPerShipment.status) }}</span>
                @if (alertsPerShipment.judgedReason) {
                  <mat-icon
                    [matTooltip]="
                      getJudgedReasonMessage(alertsPerShipment.judgedReason)
                    "
                    matTooltipClass="tw-whitespace-pre-line matp-medium-tooltip"
                    class="tw-text-[18px] tw-ml-1"
                  >
                    info
                  </mat-icon>
                }
              </div>
              <div class="tw-flex tw-justify-items-start">
                <div class="tw-flex-col tw-w-full">
                  発生日時：
                  {{ alertsPerShipment.eventAt | date: "yyyy/MM/dd HH:mm:ss" }}
                </div>
                @if (isResolved(alertsPerShipment)) {
                  <div class="tw-flex-col tw-w-full tw-ml-4">
                    解除日時：
                    {{
                      alertsPerShipment.resolvedAt | date: "yyyy/MM/dd HH:mm:ss"
                    }}
                  </div>
                }
              </div>
            </div>
          </div>
        }
      }
    </mat-expansion-panel>
  </mat-accordion>

  @if (alertList.length < 1 && !loading) {
    <div>対象期間内に配送アラートはありません。</div>
  }
</div>
